__turbopack_context__.v({
  "avatarRing": "Testimonials-module__Fpjnva__avatarRing",
  "cardBox": "Testimonials-module__Fpjnva__cardBox",
  "cardsTrack": "Testimonials-module__Fpjnva__cardsTrack",
  "controlsRow": "Testimonials-module__Fpjnva__controlsRow",
  "headerArea": "Testimonials-module__Fpjnva__headerArea",
  "mainTitle": "Testimonials-module__Fpjnva__mainTitle",
  "navButton": "Testimonials-module__Fpjnva__navButton",
  "quoteText": "Testimonials-module__Fpjnva__quoteText",
  "roleTag": "Testimonials-module__Fpjnva__roleTag",
  "sectionContainer": "Testimonials-module__Fpjnva__sectionContainer",
  "starGroup": "Testimonials-module__Fpjnva__starGroup",
  "subTag": "Testimonials-module__Fpjnva__subTag",
  "titleOutline": "Testimonials-module__Fpjnva__titleOutline",
  "trackViewport": "Testimonials-module__Fpjnva__trackViewport",
});
